import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  FiBarChart2,
  FiUsers,
  FiSettings,
  FiDollarSign,
} from 'react-icons/fi';
import { isAuthenticated } from '../../lib/auth';
import api from '../../lib/api';
import AdminLayout from '../../components/AdminLayout';

const SettingsPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [adminUser, setAdminUser] = useState<any>(null);

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/admin/login');
      return;
    }

    // Fetch current admin user
    api.get('/auth/me')
      .then((res) => setAdminUser(res.data.user))
      .catch((err) => console.error('Failed to fetch admin user:', err));
  }, [navigate]);

  return (
    <AdminLayout>
      <h1 style={{ fontSize: '1.375rem', marginBottom: '28px' }}>{t('admin.settings')}</h1>

        {/* Settings Sections */}
        <div style={{ maxWidth: '800px' }}>
          {/* Profile Section */}
          <div
            style={{
              background: '#1a202c',
              border: '1px solid #2d3748',
              borderRadius: '12px',
              padding: '24px',
              marginBottom: '20px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <FiUsers size={20} />
              <h2 style={{ margin: 0 }}>{t('admin.profile' as string) || 'Profile'}</h2>
            </div>
            {adminUser && (
              <div style={{ display: 'grid', gap: '12px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '14px', color: '#a0aec0', marginBottom: '4px' }}>
                    {t('admin.email' as string) || 'Email'}
                  </label>
                  <div style={{ padding: '8px 12px', background: '#0d1117', borderRadius: '6px' }}>
                    {adminUser.email}
                  </div>
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '14px', color: '#a0aec0', marginBottom: '4px' }}>
                    {t('admin.name' as string) || 'Name'}
                  </label>
                  <div style={{ padding: '8px 12px', background: '#0d1117', borderRadius: '6px' }}>
                    {adminUser.name}
                  </div>
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '14px', color: '#a0aec0', marginBottom: '4px' }}>
                    {t('admin.role' as string) || 'Role'}
                  </label>
                  <div style={{ padding: '8px 12px', background: '#0d1117', borderRadius: '6px' }}>
                    {adminUser.role}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* System Info */}
          <div
            style={{
              background: '#1a202c',
              border: '1px solid #2d3748',
              borderRadius: '12px',
              padding: '24px',
              marginBottom: '20px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <FiSettings size={20} />
              <h2 style={{ margin: 0 }}>{t('admin.system' as string) || 'System'}</h2>
            </div>
            <div style={{ display: 'grid', gap: '12px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '14px', color: '#a0aec0', marginBottom: '4px' }}>
                  {t('admin.version' as string) || 'Version'}
                </label>
                <div style={{ padding: '8px 12px', background: '#0d1117', borderRadius: '6px' }}>
                  v1.0.0
                </div>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '14px', color: '#a0aec0', marginBottom: '4px' }}>
                  {t('admin.environment' as string) || 'Environment'}
                </label>
                <div style={{ padding: '8px 12px', background: '#0d1117', borderRadius: '6px' }}>
                  {process.env.NODE_ENV || 'development'}
                </div>
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div
            style={{
              background: '#1a202c',
              border: '1px solid #2d3748',
              borderRadius: '12px',
              padding: '24px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <FiDollarSign size={20} />
              <h2 style={{ margin: 0 }}>{t('admin.quickActions' as string) || 'Quick Actions'}</h2>
            </div>
            <div style={{ display: 'grid', gap: '12px' }}>
              <button
                onClick={() => navigate('/admin/stock')}
                style={{
                  padding: '12px 20px',
                  borderRadius: '8px',
                  border: '1px solid #2d3748',
                  background: '#2d3748',
                  color: 'white',
                  cursor: 'pointer',
                  textAlign: 'left',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <FiBarChart2 size={18} />
                {t('admin.manageStock' as string) || 'Manage Stock'}
              </button>
              <button
                onClick={() => navigate('/admin/capacity')}
                style={{
                  padding: '12px 20px',
                  borderRadius: '8px',
                  border: '1px solid #2d3748',
                  background: '#2d3748',
                  color: 'white',
                  cursor: 'pointer',
                  textAlign: 'left',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <FiBarChart2 size={18} />
                {t('admin.manageCapacity' as string) || 'Manage Capacity'}
              </button>
            </div>
          </div>
        </div>
    </AdminLayout>
  );
};

export default SettingsPage;
